import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { thousandize } from "../../../../util/formatting";
import styles from "./ResultsTeaser.module.scss";
import LinkButton from "../../../shared/components/EffektButton/LinkButton";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
export const ResultsTeaser: React.FC<{
  title: string;
  sumSubtitle?: string;
  donorsSubtitle?: string;
  seeMoreButton?: NavLink;
  locale: string;
}> = t0 => {
  const $ = _c(28);
  const {
    sumSubtitle,
    donorsSubtitle,
    seeMoreButton,
    locale
  } = t0;
  const [data, setData] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      fetch(`${process.env.NEXT_PUBLIC_EFFEKT_API}/results/headline`).then(_temp).then(data_0 => setData(data_0.content)).catch(console.error);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== data?.totalDonationsToRecommendedOrgs || $[3] !== locale) {
    t3 = thousandize(Math.round(parseFloat(data?.totalDonationsToRecommendedOrgs ?? "0")), locale);
    $[2] = data?.totalDonationsToRecommendedOrgs;
    $[3] = locale;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className={styles.headlineNumber}>{t3}{" "}kr</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== sumSubtitle) {
    t5 = <span>{sumSubtitle}</span>;
    $[7] = sumSubtitle;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = data?.numberOfDonors ?? 0;
  let t8;
  if ($[12] !== locale || $[13] !== t7) {
    t8 = thousandize(t7, locale);
    $[12] = locale;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <span className={styles.headlineNumber}>{t8}</span>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== donorsSubtitle) {
    t10 = <span>{donorsSubtitle}</span>;
    $[17] = donorsSubtitle;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== seeMoreButton) {
    t12 = seeMoreButton && seeMoreButton.slug && <div><LinkButton url={"/" + seeMoreButton.slug} title={seeMoreButton.title || "See more"} /></div>;
    $[22] = seeMoreButton;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12 || $[26] !== t6) {
    t13 = <div className={styles.container}><div className={styles.grid}>{t6}{t11}{t12}</div></div>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
function _temp(response) {
  return response.json();
}